import { render, staticRenderFns } from "./difflist.vue?vue&type=template&id=93dddb3e&scoped=true&"
import script from "./difflist.vue?vue&type=script&lang=js&"
export * from "./difflist.vue?vue&type=script&lang=js&"
import style0 from "./difflist.vue?vue&type=style&index=0&id=93dddb3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dddb3e",
  null
  
)

export default component.exports